import { render, staticRenderFns } from "./binding2.vue?vue&type=template&id=073c1074&scoped=true&"
import script from "./binding2.vue?vue&type=script&lang=js&"
export * from "./binding2.vue?vue&type=script&lang=js&"
import style0 from "./binding2.vue?vue&type=style&index=0&id=073c1074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073c1074",
  null
  
)

export default component.exports